module.exports = __webpack_public_path__ + "static/process-bg-31c9f97f404be6281a726f2911b6a3dd.jpg";